// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },

    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      SECTION: {
        MEMBER: 'Member',
        RAW_MATERIAL: 'Raw Material',
        MANAGE_FARMING: 'Farming Management',
        SETTING: 'Setting',
        CONTRACT: 'Contract/Lot',
        ACCOUNT: 'Account',
        REPORT: 'Report',
      },
      MEMBER: {
        TITLE: 'Member Information',
        AGENT_INFORMATION: 'Agent Information',
        FARM_INFORMATION: 'Farm Information',
        MESSAGING: 'Messages',
      },
      RAW_MATERIAL: {
        TITLE: 'Inventory',
        SUB_TITLE_ONE: 'Raw Material Buy System',
        SUB_TITLE_TWO: 'Raw Material Sell System',
        SUB_TITLE_THREE: 'Raw Material Management System',
        PRE_ORDER: 'POS',
        PURCHASE_ORDER: 'Purchase Order',
        RAW_MATERIAL_CLAIM: 'Raw Material claim',
        RETURN_ORDER: 'Send Claims',
        RAW_MATERIAL_RECEIVING: 'Raw Material Receiving',
        RAW_MATERIAL_REQUISITION: 'Raw Material Requisition',
        RAW_MATERIAL_RETURN: 'Raw Material Return',
        STOCK_ADJUST: 'Stock Adjust',
        RAW_MATERIAL_BID: 'Quotation',
        RAW_MATERIAL_SELL: 'Raw Material Sell',
        RAW_MATERIAL_BUY: 'Raw Material Buy',
        RAW_MATERIAL_DEPOSIT: 'Deposit',
        RAW_MATERIAL_RECEIVE_CLAIM: 'Receive Claim',
        RAW_MATERIAL_SEND_CLAIM: 'Return Claim',
        REDUCE_DEBT: 'Reduce Debt',
        ADD_DEBT: 'Add Debt',
        SEND_ORDER: 'Send Order',
        UNIT_DISCOUNT: 'Discount Unit',
      },
      ACCOUNT_SETTING: {
        TITLE: 'Account Setting',
        EXPENSES: 'Expenses Information',
        ACCEPT_DEBT: 'Account Receive Information',
        PAY_OFF_DEBT: 'Account Payable Information',
        EMPLOYEE_WAGES: 'Enployee Wages Information',
        MEMBER_DIVIEND_PAYMENT: 'Member Dividend Payment Information',
        OTHER_INCOME: 'Other Income Information',
      },
      MANAGE_FARMING: {
        TITLE: 'Farming management system',
        FARMING_TYPE: {
          TITLE: 'Farming Type',
          ACTIVITY_TYPE: 'Activity Type',
          FARMING_ACTIVITY: 'Farming Activity',
          FARMING_TYPE: 'Farming type',
          CROP_REQUIREMENT: 'Standard Setting',
          ACTIVITY: 'Activity information',
        },
        FARMING_INFORMATION: {
          TITLE: 'Farming Information',
          FARMING_INFORMATION: 'Farming Information',
          EXPENSE_INFORMATION: 'Expense Information',
          ENVIRONMENT_INFORMATION: 'Environment Information',
          WASTING_INFORMATION: 'Wasting Information',
          GROWTH_INFORMATION: 'Growth Information',
          HAVEST_INFORMATION: 'Havest Information',
        },
        PRODUCTION_PLAN: {
          TITLE: 'Production Plan',
          ORDER_PLAN: 'Order Plan',
          ANALYZE_ORDERS: 'Anayze Orders',
          REPORT_PLAN: 'Report Production Plan',
        },
      },
      CONTRACT_LOT: {
        TITLE: 'Contract and lot management system',
        CONTRACT_INFORMATION: 'Contract Information',
        LOT_INFORMATION: 'Lot Information',
      },
      REPORT: {
        TITLE: 'Report',
        WAREHOUSE_REPORT: {
          TITLE: 'Warehouse Report',
          INVENTORY_REPORT: 'Inventory Report',
          CLAIM_REPORT: 'Claim Report',
          REPORT_BACK: 'Return Report',
        },
        ACCOUNTING_REPORT: {
          TITLE: 'Accounting Report',
          CASH_FLOW_STATEMENT: 'Cash Flow Statement Report',
          CREDITOR_REPORT: 'Creditor Report',
          DEBTOR_REPORT: 'Debtor Report',
          EXPENSES_REPORT: 'Expenses Report',
          INCOME_STATEMENT: 'Income Statement Report',
        },
        ANALYSIS_REPORT: {
          TITLE: 'Analysis Report',
          CASH_FLOW_MANAGEMENT: 'Cash Flow Management Report',
          FARMING_REPORT: 'Farimg Report',
          FEED_FERTILIZE: 'Feed & Fertilize Report',
          HARVEST_REPORT: 'Harvest Report',
          PERFORMANCE_ANALYSIS: 'Perormance Analysis Report',
          PRODUCT_TRUCK: 'Product Truck Report',
          PURCHASE_RAW_MATERIAL: 'Purchase Raw Material Report',
          RAW_MATERIAL_TRUCK: 'Raw Material Truck Report',
          STOCK_ADJUSTMENT: 'Stock Adjusment Report',
        },
        ENVIRONMENT_REPORT: {
          TITLE: 'Environment Report',
          ENVIRONMENT_VALUE: 'Environment Value Report',
        },
        GENERAL_REPORT: {
          TITLE: 'General Report',
          CLOSE_LOT_REPORT: 'Close Lot Report',
          CONTRACT_REPORT: 'Contract Report',
          PAY_DEVEDENDS_REPORT: 'Pay Dividends Report',
          RECEIVE_MONEY_REPORT: 'Receive Money Report',
          TAX_REPORT: 'Tax Report',
          PURCHASE_TAX_REPORT: 'Purchase Tax Report',
          SALE_TAX_REPORT: 'Sale Tax Report',
          WAGE_REPORT: 'Wage Report',
        },
        PRODUCTION_EFFICIENCY: {
          TITLE: 'Production Efficiency Report',
          FEED_FERTILIZE_DRUG: 'Feed & Fertilize & Drug Report',
          GROWTH_REPORT: 'Growth Report',
          PRODUCT_COST: 'Product Cost Report',
          PRODUCT_COST_ACTIVITY_TYPE: 'Product Cost by Activity Type Report',
          PRODUCT_QUANTITY: 'Product Quantity Report',
          WASTING_REPORT: 'Wasting Report',
        },
        PURCHASE_REPORT: {
          TITLE: 'Purchase Report',
          PURCHASE_PRODUCT: 'Purchase Product Report',
          PURCHASE_RAW_MATERIAL: 'Purchase Raw Material Report',
        },
        SALES_REPORT: {
          TITLE: 'Sales Report',
          SALES_PRODUCT: 'Sales Produc Report',
          SALES_RAW_MATERIAL: 'Sales Raw Material Report',
        },
      },

      SETTING: {
        TITLE: 'Setting',
        GENERAL_SETTING: {
          TITLE: 'General Setting',
          GENERAL_INFORMATION: 'General Information',
          CUSTOMER_INFORMATION: 'Customer Information',
          SUPPLIER_INFORMATION: 'Supplier Information',
          ACCOUNT_INFORMATION: 'Bank Account Information',
          EXPENSE_INFORMATION: 'Expense Information',
          OTHER_INCOME: 'Other Income',
        },
        STAFF_SETTING: {
          TITLE: 'Staff Setting',
          STAFF_INFORMATION: 'Staff Information',
          PERMISSION: 'Permission',
          POSITION: 'Position',
        },
        RAW_MATERIAL_SETTING: {
          TITLE: 'Raw Material Setting',
          UNIT: 'Unit',
          RAW_MATERIAL_TYPE: 'Raw Material Type',
          RAW_MATERIAL_LIST: 'Raw Material List',
        },
        INITIAL_SETTING: {
          TITLE: 'Initial Setting',
          INITIAL_CASH: 'Initial Cash',
          INITIAL_RAW_MATERIAL: 'Initial Raw Material',
        },
        SHAREHOLDER_SETTING: {
          TITLE: 'Shareholder Setting',
          SHAREHOLDER_INFORMATION: 'Shareholder Infotmation',
          DIVIDEND_RATIOS: 'Davidend Ratios',
        },
        POS_SETTING: {
          TITLE: 'POS Seetting',
          WAREHOUSE_SETTING: 'Warehouse Setting ',
          TRANSFER_SETTING: 'Transfer Setting ',
          MENU_SETTING: 'Menu Setting ',
          CATEGORY_SETTING: 'Category Setting ',
          ROUNDING_OFF_SETTING: 'Rounding Off Setting ',
          CANCELLATION_SETTING: 'Cancellation Setting ',
          PRINTER_SETTING: 'Printer Setting ',
          POS_SETTING: 'POS Setting ',
          PROMOTION_SETTING: 'Promotion Setting ',
        },
      },
    },

    LABEL_LIST: {
      NO_DATA: 'No data',
    },

    //Report
    INCOME_STATEMENT: {
      LIST: 'List',
      AMOUNT_MONEY: 'Money amount (Baht)',
      INCOME: 'Breed income',
      INCOME_FOOD: 'Food income',
      INCOME_RAW_OTHER: 'Other raw material income',
      INCOME_PRODUCT: 'Sale product income',
      INCOME_OTHER: 'Other income',
      INCOME_TOTAL: 'Total income',
      COST_OF_SALE: 'Cost of sales',
      COST: 'Breed cost',
      COST_FOOD: 'Food cost',
      COST_RAW_OTHER: 'Other raw material cost',
      COST_PRODUCT: 'Product cost',
      COST_OTHER: 'Other cost',
      COST_TOTAL: 'Total cost',
      INITIAL_PROFIT: 'Initial profit (Loss)',
      SELLING_ADMINISTER: 'Selling and Administrative expenses',
      SELLING: 'Selling expenses',
      ADMINISTER: 'Aminitrative expenses',
      OTHER_EXPENSE: 'Other expenses',
      EXPENSE_TOTAL: 'Total expenses',
      NET_PROFIT: 'Net profit (Loss)',
      CREDIT_DEBTOR: 'Credit (Debtor)',
      SALE_TAX: 'Sale TAX',
      TOTAL_CASH_FLOW: 'Total cash flow receive',
      CASH_FLOW_RECEIVE: 'Cash flow receive',
      CASH_FLOW_PAY: 'Cash flow pay',
      RAW_PRODUCT: 'Raw material and Product',
      PURCHASE_TAX: 'Purchases TAX',
      EXPENSE: 'Expenses',
      SALARY: 'Salary',
      WAGES: 'Wages',
      CREDIT_CREDITOR: 'Credit (Creditor)',
      TOTAL_CASH_FLOW_PAY: 'Total cash flow pay',
      NET_CASH: 'Net cash',
      INITIAL_INSTALLMENT_CASH: 'Initial installment cash',
      LAST_INSTALLMENT_CASH: 'Last installment cash',
      PRODUCT: 'Product',
      OTHER: 'Other',
    },
    RECEIVE: {
      DATE: 'Date',
      DOC_NO: 'Receipt number/Invoice number',
      PAYMENT_TYPE: 'Payment type',
      PRICE_BEFORE_DISCOUNT: 'Price before discount',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      VAT: 'Vat',
      NET: 'Net',
      STATUS: 'Status',
      PRINT: 'Print',
    },
    PURCHASE_TAX: {
      DATE: 'Date',
      DOC_NO: 'Document No.',
      NAME: 'Vendor/provider name',
      CUSTOMER_NAME: 'Customer name',
      TAX_NO: 'Vendor Identification number',
      COMPANY: 'Company',
      LOCATION: 'Location',
      VALUE_BEFORE_VAT: 'Value before vat',
      VAT: 'Vat',
      TOTAL: 'Total',
      STATUS: 'Status',
      DEALER: 'Dealer',
      PAYMENT_TYPE: 'Payment type method',
      TOTAL_BAHT: 'Total (Baht)',
      TOTAL_CASH: 'Total Cash (Baht)',
      TOTAL_CREDIT: 'Total credit (Baht)',
      TOTAL_NET: 'Net (Baht)',
      DES: 'Description',
      RAW: 'Raw matrial',
      AMOUNT: 'Amount',
      UNIT: 'Unit',
      MEMBER: 'Member',
      LOT: 'Lot',
      PRODUCT: 'Product name',
      UNIT_PRICE: 'Unit price (Baht)',
      CUSTOMER: 'Customer',
      RAW_MAT: 'Raw material/Product',
    },
    CONTRACT: {
      DATE: 'Date',
      CONTRACT_NO: 'Contract No.',
      CONTRACT_NAME: 'Contract name',
      PURCHASE_DIFF: 'Purchases Difference (Baht)',
      NUM_OF_BREED: 'Number of Breeds (Lot)',
      SECURITY_DEPOSIT: 'Security Deposit (Baht)',
      DESCRIPTION: 'Description',
      CONTRACT: 'Contract',
      NAME_LOT: 'Name lot',
      INSURANCE: 'Product insurance price (Baht)',
      INCOME: 'Net income of lot (Baht)',
      STAUS: 'Lot status (on/off)',
      MAXIMUM: 'Maximum',
      MINIMUM: 'Minimum',
      UNIT: 'Unit',
      SHOW: 'Show All',
      LOT: 'Lot',
      DATE_RAISING_PLANTINT: 'Start raising/planting (Date)',
      RAW_RAISING_PLANTINT: 'Start raising/planting (Raw material)',
      AMOUNT: 'Amount',
      PRODUCT: 'Product',
      START_DATE: 'Start date',
      REARING_PLANTING_DURATION: 'Rearing/Planting duration',
      AMOUNT_PLAN: 'Start Rearing/Planting  (Plan)',
      AMOUNT_TRUE: 'Start Rearing/Planting  (true)',
      LIST: 'List',
      PLAN_REARING: 'Plan rearing date amount',
      AMOUNT_RAW_REMAIN: 'Raw material remain amount',
      AMOUNT_FOOD_REQUIRED: 'Amount of food reduired per day (Kg.)',
      REQUIRED: 'Required food (Kg.)',
      AMOUNT_REARING: 'Rearing amount (Day)',
      ADD_FOOD: 'Additional food required (Kg.)',
      PREDICT_PRODUCT: 'Predict product (Kg.)',
      DATE_KEEP_PRODUCT: 'Date of keep product',
      NAME_ACTIVITY: 'Name activity',
      AMOUNT_DEFAULT: 'Amount of raw material',
      DEAD: 'Death rate (%)',
      SURVIVE: 'Survive rate (%)',
      GROWTH: 'Growth rate (%)',
      TEST: 'Rate (%)',
      WEIGHT: 'Average weight',
      AMOUNT_FOOD: 'Amount of food per person',
    },
    PURCHASE_REPORT: {
      LIST: 'List',
      AMOUNT_REMAIN: 'Remain amount',
      AMOUNT_PER_DAY: 'Amount per day',
      AMOUNT_DATE: 'Amount date',
      TO: 'To',
      ORDER_BEFORE_DATE: 'Order before date',
    },
    TRANPORT_REPORT: {
      MONTH: 'Month',
      DATE: 'Day/Month/Year',
      AMOUNT_DAY: 'Date amount',
      REF: 'Referance amount last year',
      PLAN_SALES: 'Plan sales',
      ADJUST: 'Adjust',
      TOTAL: 'Total',
      REF_LAST_YEAR: 'year',
      PLAN_SALES_DAY: 'Plan sales (Kg./Day)',
      ADJUST_DAY: 'Adjust (Kg./Day)',
      TOTAL_KG: 'Total (Kg.)',
      DOC_NO_DELIVERY: 'Delivery document number',
      CUSTOMER_NAME: 'Customer name',
      DOC_NO: 'Sale document number',
      SALES_DATE: 'Sale date',
      NET_DELIVERY: 'Deleverly Net.',
      LOCATION: 'Location',
      ADDRESS: 'Address',
      LIST: 'List',
      AMOUNT: 'Amount',
      UNIT: 'Unit',
      UNIT_PRICE: 'Unit price',
      DELIVERY_NET: 'Delevery Net.',
      SV: '%SV (Survival rate)',
      AMOUNT_REARING: 'Amount rearing',
      AVERAGE: 'Average rearing duration',
      START: 'Start raising (Date)',
      PHONE: 'Phone',
      STATUS: 'Delivery status',
      DETAIL: 'Detail',
    },
    CASH_FLOW: {
      BEGIN_CASH: 'Beginning cash',
      AMOUNT: 'Amount (Baht)',
      RECEIVE_CASH: 'Receive cash',
      RECEIVE_CASH_SALE: 'Receive cash for sales',
      RECEIVE_CASH_DEBTOR: 'Receive cash from debtor',
      PAY_CASH: 'Pay cash',
      PAY_CASH_PURCHASE: 'Pay cash purchase raw material',
      PAY_CASH_BUY: 'Pay cash buy product',
      PAY_CASH_CREDITOR: 'Pay cash credit(Creditor)',
      PAY_CASH_EXPENSE: 'Pay cash expenses',
      PAY_CASH_SALARY: 'Pay cash salary',
      PAY_CASH_WAGE: 'Pay cash wages',
      PAY_CASH_NET: 'Total pay cash',
      PAY_CASH_LAST: 'Total Net.',
      DATE_RECEIVE_MONEY: 'Estimate date of receive(debtor) - Pay(creditor)',
      CREDIT_TERM: 'Credit term group',
      TERM: 'Credit term',
      DAY: 'Day',
      TERM_30: 'Credit term 30 days',
      CREDIT_NOT_RECEIVE: 'Credit not receive (Debtor)',
      CREDIT_NOT_RECEIVE_CREDITOR: 'Credit not receive (Creditor)',
      DATE_TO_SALES: 'Date to sales',
      REMAIN_RECEIVE: 'Remain not paid',
      DUE_DATE: 'Due date',
      DATE_TO_PURCHASER: 'Date to purchases',
      REMAIN_PAY: 'Remain not pay',
    },

    //Member Information
    FARM_INFORMATION: {
      TITLE: 'Farm Information',
      CREATE_FARM: 'Create farm',
      EDIT_FARM: 'Edit farm',
      NAME_LIST: 'Name',
      PHONE: 'Phone',
      FARM_NAME: 'Farm no.',
      OWNER: 'Owner',
      REGIS_ID: 'Registration number',
      NAME: 'First name',
      LAST_NAME: 'Last name',
      OGANIZATION: 'Oganization name',
      CARD_ID: 'ID Number',
      CARD_END_DATE: 'Card Expiration Date',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      EMAIL: 'Email',
      FAX: 'Fax',
      LAT: 'Latitude',
      LONG: 'Longitude',
      COORDINATES: 'Coordinates',
      CLAY_SET: 'Clay Set',
      MINERAL_CONTENT: 'Mineral Content',
      NPK: 'NPK',
      PLOT_SIZE: 'Plot Size',
      PLOT_PICTURE: 'Plot Picture',
      PLOT_NAME: 'Plot Name',
      USERNAME: 'Username',
      PASSWORD: 'Password',
      CON_PASSWORD: 'Confirm password',
      CREDIT: 'Credit term (day)',
    },
    AGENT_INFORMATION: {
      TITLE: 'Agent Information',
      CREATE: 'Create Member',
      CREATE_MEMBER: 'Create Employee',
      CREATE_AGENT: 'Create agent',
      EDIT_AGENT: 'Edit agent',
      TITLE_LIST: 'Member List',
      NAME_LIST: 'Name',
      PHONE: 'Phone',
      FARM_NAME: 'Member number',
      REGIS_ID: 'Registration number',
      OGANIZATION: 'Oganization name',
      NAME: 'First name',
      LAST_NAME: 'Last name',
      CARD_ID: 'ID Number',
      CARD_END_DATE: 'Card Expiration Date',
      TYPE_CONTRACT: 'Farm Type',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      EMAIL: 'Email',
      FAX: 'Fax',
      LAT: 'Latitude',
      LONG: 'Longitude',
      USERNAME: 'Username',
      PASSWORD: 'Password',
      CON_PASSWORD: 'Confirm password',
      TYPE_SYSTEM_ACCOUNT: 'System Account Type',
    },
    MESSAGING: {
      TITLE: 'Notify Message',
      CREATE: 'Create Notify Message',
      EDIT: 'Edit Notify Message',
      TITLE_MESSAGING: 'Message',
      CREATE_MESSAGING: 'Create Message',
      EDIT_MESSAGING: 'Message',
      DATE: 'Date',
      TIME: 'Time',
      MESSAGING: 'Message',
      HEADER: 'Header',
      MEMBER: 'Member',
      MEMBER_ALL: 'Choose All Member',
      RECEIVE: 'Receiving',
      SENDING: 'Sending',
      FROM: 'From',
      TO: 'To',
    },

    //Raw Material
    PRE_ORDER: {
      TITLE_LIST: 'POS list',
      CREATE_PURCHASE: 'Create POS',
      SHOW_PURCHASE: 'POS',
      DATE: 'Date',
      DOC_NO: 'Document number',
      IS_CREATE_AUTO: 'Create receiving auto',
      DEALER: 'Dealer name',
      ADDRESS: 'Dealer address',
      PAYMENT: 'Payment method',
      STATUS_DOC: 'Document status',
      STATUS_PAYMENT: 'Payment status',
      TITLE: 'POS',
      READ_FROM: 'Read from',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PICK_UP_DATE: 'Pick up date',
      PAYMENT_DATE: 'Payment date',
      PAYMENT_TYPE: 'Payment type',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Total',
      DISCOUNT: 'Discount',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      LIST_RAW_MATERIAL: 'Raw material Order list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      AMOUNT_RECEIVE: 'Receive amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      NUMBER: 'No.',
      DEADLINE_DATE: 'Deadline Date',
      DELIVERY_ADDRESS: 'Delivery Address',
    },
    PURCHASE_ORDER: {
      TITLE_LIST: 'Purchase order list',
      CREATE_PURCHASE: 'Create purchase order',
      SHOW_PURCHASE: 'Purchase order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      IS_CREATE_AUTO: 'Create receiving auto',
      DEALER: 'Dealer name',
      ADDRESS: 'Dealer address',
      PAYMENT: 'Payment method',
      STATUS_DOC: 'Document status',
      STATUS_PAYMENT: 'Payment status',
      TITLE: 'Purchase order',
      READ_FROM: 'Read from',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PICK_UP_DATE: 'Pick up date',
      PAYMENT_DATE: 'Payment date',
      PAYMENT_TYPE: 'Payment type',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Total',
      DISCOUNT: 'Discount',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      LIST_RAW_MATERIAL: 'Raw material purchase list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      AMOUNT_RECEIVE: 'Receive amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
    },
    RAW_MATERIAL_RECEIVING: {
      TITLE_LIST: 'Raw material receiving list',
      CREATE_RECEIVING: 'Create receiving order',
      SHOW_RECEIVING: 'Receiving order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      DEALER: 'Dealer name',
      ADDRESS: 'Address',
      PAYMENT: 'Payment method',
      STATUS: 'Status',
      TITLE: 'Raw material receiving',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      READ_FROM: 'Read from',
      PURCHASE_ORDER: 'Purchase order',
      CLAIM_ORDER: 'Claim order',
      DOC_NO_DATE: 'Document date',
      RECEIV_DATE: 'Receiving date',
      LIST_RAW_MATERIAL_RECEIVING: 'Raw material receiving list',
      NOTE: 'Note',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      REMAIN: 'Remain',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      HAS_VAT: 'Vat',
      NO_TAX: 'No Vat',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      TAX: 'Vat',
      IS_CLAIM: 'Choose for claim',
      BALANCE: 'Balance',
      TOTAL: 'Total',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
    },
    RAW_MATERIAL_REQUISITION: {
      TITLE_LIST: 'Raw material requisition list',
      CREATE_REQUISITION: 'Create requisition order',
      SHOW_REQUISITION: 'requisition order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      DOC_NO_DATE: 'Document date',
      PICK_UP: 'Pick up',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      STATUS: 'Status',
      PICK_UP_OPERATOR: 'Pick up operator',
      TITLE: 'Requisition list',
      LIST_RAW_MATERIAL_REQUISITION: 'Raw material requisition list',
      NOTE: 'Note',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      TOTAL: 'Total',
      MEMBER: 'Member',
      UNIT_MAIN: 'Unit Main',
    },
    RAW_MATERIAL_CLAIM: {
      TITLE_LIST: 'Raw material claim list',
      CREATE_CLAIM: 'Create claim order',
      SHOW_CLAIM: 'Claim order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      DEALER: 'Dealer name',
      ADDRESS: 'Address',
      PAYMENT: 'Payment method',
      STATUS: 'Status',
      READ_FROM: 'Read from',
      DOC_NO_DATE: 'Document date',
      PURCHASE: 'Puchase order',
      TITLE: 'Claim list',
      LIST_RAW_MATERIAL_CLAIM: 'Raw material claim list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      RECEIVE_AMOUNT: 'Receive amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DURATION: 'Duration (Days)',
      IS_CLAIM: 'Claim',
      NOTE: 'Note',
      TOTAL: 'Total',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
    },

    RETURN_ORDER: {
      TITLE_LIST: 'Send Claims list',
      CREATE_CLAIM: 'Create Send Claims',
      SHOW_CLAIM: 'Send Claims',
      DATE: 'Date',
      DOC_NO: 'Document number',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      DEALER: 'Dealer name',
      ADDRESS: 'Address',
      PAYMENT: 'Payment method',
      STATUS: 'Status',
      READ_FROM: 'Read from',
      DOC_NO_DATE: 'Document date',
      PURCHASE: 'Puchase order',
      TITLE: 'Send Claims list',
      LIST_RETURN_ORDER: 'Send Claims list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      RECEIVE_AMOUNT: 'Receive amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DURATION: 'Duration (Days)',
      IS_CLAIM: 'Claim',
      NOTE: 'Note',
      TOTAL: 'Total',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      SYSTEM_ACCOUNT: 'System Account',
      SEND_OR_CLAIM: 'Send Or Claim',
    },
    RAW_MATERIAL_RETURN: {
      TITLE_LIST: 'Raw material return list',
      CREATE_RETURN: 'Create return order',
      SHOW_RETURN: 'Return order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      DEALER: 'Dealer name',
      ADDRESS: 'Address',
      PAYMENT: 'Payment method',
      STATUS: 'Status',
      READ_FROM: 'Read from',
      DOC_NO_DATE: 'Document date',
      PURCHASE: 'Puchase order',
      TITLE: 'Return list',
      LIST_RAW_MATERIAL_RETURN: 'Raw material return list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      RECEIVE_AMOUNT: 'Receive amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      IS_RETURN: 'Return',
      NOTE: 'Note',
      TOTAL: 'Total',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
    },
    STOCK_ADJUST: {
      TITLE_LIST: 'Stock adjust list',
      CREATE_STOCK_ADJUST: 'Create stock adjust',
      SHOW_STOCK_ADJUST: 'Stock adjust',
      DATE: 'Date',
      DOC_NO: 'Document number',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      STATUS: 'Status',
      DOC_NO_DATE: 'Document date',
      TITLE: 'Stock adjust',
      LIST_STOCK_ADJUSTt: 'Stock adjust list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      VALUE: 'Unit per price',
      CURENT_AMOUNT: 'Curent amount',
      CURENT_VALUE: 'Curent value',
      DESCRIPTION: 'Description',
      NET_WORTH: 'Net worth',
      UNIT_MAIN: 'Unit Main',
    },
    RAW_MATERIAL_BID: {
      TITLE_LIST: 'Quotation list',
      SHOW: 'Quotation',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Quotation',
      READ_FROM: 'Read form',
      IS_SELL: 'bid to members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'bid date',
      SALE_PERSON: 'bid person',
      LIST_RAW_MATERIAL: 'Quotation list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'bids type',
      FILED_DATE: 'filed Date',
      CREDIT_DATE: 'Credit Date',
      DEADLINE_DATE: 'Deadline Date',
      ADDRESS: 'Address',
      TEL: 'Tel',
      UNIT_DISCOUNT: 'Unit Discount',
    },
    RAW_MATERIAL_SELL: {
      TITLE_LIST: 'Raw material sell list',
      TITLE_LIST_POS: 'Raw material sell POS list',
      SHOW: 'Raw material sell',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Raw material sell',
      READ_FROM: 'Read form',
      IS_SELL: 'Sell to members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SENT_DATE: 'Sent date',
      SALE_PERSON: 'Sell person',
      LIST_RAW_MATERIAL: 'Raw material sell list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      READ_FROM_DEPOSIT: 'Read form Deposit',
      DEPOSIT: 'Deposit',
      VALUE_DEPOSIT: 'Value Deposit',
      VALUE_AFTER_DEPOSIT: 'Value After Deposit',
    },
    RAW_MATERIAL_BUY: {
      TITLE_HAVEST_LIST: 'Havest information list',
      CONTRACT_FARM: 'Contract farm',
      PRODUCT: 'Product',
      HAVEST_DATE: 'Havest date',
      TITLE_LIST: 'Raw material buy list',
      DATE: 'Date',
      STATUS: 'Status',
      DOC_NO: 'Document number',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      CONTRACT: 'Contract',
      PAYMENT_TYPE: 'Payment type',
      PRODUCT_INFORMATION: 'Product information for each lot',
      LIST_HAVEST: 'Havest information list',
      LOT: 'Lot',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT_RAW: 'Amount product',
      AMOUNT: 'Amount',
      AMOUNT1: 'Amount purchase',
      VALUE: 'Value',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      TITLE_HAVEST: 'Havest information',
      TITLE: 'Raw material buy',
      SHOW_PURCHASE: 'Raw material buy',
      RECEIVING_MONEY_TYPE: 'Receiving money type',
      LIST_BUY: 'Raw material buy list',
    },

    RAW_MATERIAL_DEPOSIT: {
      TITLE_LIST: 'Deposit list',
      SHOW: 'Deposit',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Deposit',
      READ_FROM: 'Read form',
      IS_SELL: 'members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'person',
      LIST_RAW_MATERIAL: 'Deposit list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      PRICE_AFTER_DEPOSIT: 'Price after Deposit',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      RECEIVE_DATE: 'Receive Date',
      TEL: 'Tel',
      QUOTATION: 'Quotation',
      DEPOSIT: 'Deposit',
      TOTAL_DEPOSIT: 'Total Deposit',
      UNIT_DEPOSIT: 'Unit Deposit',
    },

    RAW_MATERIAL_RECEIVE_CLAIM: {
      TITLE_LIST: 'Receive Claim list',
      SHOW: 'Receive Claim',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Receive Claim',
      READ_FROM: 'Read form',
      IS_SELL: 'members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'person',
      LIST_RAW_MATERIAL: 'Receive Claim list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      RECEIVE_OR_CLAIM: 'Receive Or Claim',
      RECEIVE_AMOUNT: 'Amount Date Receive - claim',
      DURATION: 'Duration (Days)',
      IS_CLAIM: 'Choose for claim',
      IS_STOCK: 'Choose for Stock',
    },

    RAW_MATERIAL_SEND_CLAIM: {
      TITLE_LIST: 'Return Claim list',
      SHOW: 'Return Claim',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Return Claim',
      READ_FROM: 'Read form',
      IS_SELL: 'members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'person',
      LIST_RAW_MATERIAL: 'Return Claim list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      CLAIM_AMOUNT: 'Amount Claim',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      RECEIVED_CLAIM: 'Received Claim',
      UNIT_DISCOUNT: 'Unit Discount',
    },

    REDUCE_DEBT: {
      TITLE_LIST: 'Reduce Debt list',
      SHOW: 'Reduce Debt',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Reduce Debt',
      READ_FROM: 'Read form',
      IS_SELL: 'Sell to members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'Sell person',
      LIST_RAW_MATERIAL: 'Reduce Debt list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      VALUE_OLD: 'Value Old',
      VALUE_NEW: 'Value New',
      DIFFERENCE: 'Difference',
      RECEIVED_CLAIM: 'Received Claim',
      ADDRESS: 'Address',
      ORIGINAL_DOC_NO: 'Original Doc No',
      SEND_CLAIM: 'Received Return',
      CAUSE: 'Cause',
      DIFFERENCE_ALL: 'All Difference',
      CUSTOMER_MEMBER: 'Customer/Member',
    },

    ADD_DEBT: {
      TITLE_LIST: 'Add Debt list',
      SHOW: 'Add Debt',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Add Debt',
      READ_FROM: 'Read form',
      IS_SELL: 'Sell to members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'Sell person',
      LIST_RAW_MATERIAL: 'Add Debt list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      VALUE_OLD: 'Value Old',
      VALUE_NEW: 'Value New',
      DIFFERENCE: 'Difference',
      RETURN_CLAIM: 'Return claim',
      RECEIVED_CLAIM: 'Received Claim',
      ADDRESS: 'Address',
      ORIGINAL_DOC_NO: 'Original Doc No',
      SEND_CLAIM: 'Received Return',
      CAUSE: 'Cause',
      DIFFERENCE_ALL: 'All Difference',
      CUSTOMER_MEMBER: 'Customer/Member',
    },

    SEND_ORDER: {
      TITLE_LIST: 'Send Order list',
      SHOW: 'Send Order',
      DATE: 'Date',
      DOC_NO: 'Document number',
      PAYMENT_TYPE: 'Payment type',
      STATUS: 'Status',
      TITLE: 'Send Order',
      READ_FROM: 'Read form',
      IS_SELL: 'Sell to members',
      CUSTOMER: 'Customer',
      MEMBER: 'Member',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      PAYMENT_DATE: 'Payment date',
      SALE_PERSON: 'Sell person',
      LIST_RAW_MATERIAL: 'Send Order list',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      UNIT_PRICE: 'Unit per price',
      TOTAL_LIST: 'Total',
      DISCOUNT: 'Discount',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      IS_VAT: 'Vat',
      NOTE: 'Note',
      NO_TAX: 'No TAX',
      TAX: 'TAX',
      TOTAL: 'Tatal',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TOTAL_TABLE: 'Total',
      SALE_TYPE: 'Sales type',
      DELIVERY_DATE: 'Delivery Date',
    },

    REPORT: {
      TITLE: 'Report',
      WAREHOUSE_REPORT: {
        TITLE: 'Warehouse Report',
        INVENTORY_REPORT: 'Inventory Report',
        INVENTORY: 'Inventory',
        INVENTORY_POS: 'Inventory POS',
        CLAIM_RECEIVE_REPORT: 'Claim/Receive claim Report',
        CHOOSE_CLAIM_RECEIVE: 'Choose Claim/Receive claim',
        CLAIM_RECEIVE: 'Claim/Receive claim',
        REPORT_BACK: 'Report Back',
        DATE: 'DAte',
        CONTRACT_NAME: 'Contact Name',
        STATUS: 'Status',
        DETAIL: 'Details',
        SEE_DETAIL: 'See Details',
        RAW_MATERIAL_LIST: 'Raw material list',
        AMOUNT: 'Amount',
        UNIT: 'Unit',
        CLAIM_PERIOD: 'Claim period (days)',
        TYPE: 'Type',
        CHOOSE_TYPE: 'Choose Type',
        LIST: 'List',
        AMOUNT_IMPORTS: 'Amount Imports',
        VALUE_BAHT: 'Value (Baht)',
        REMAIN: 'Remain',
      },
    },

    //Account Setting
    EXPENSES: {
      TITLE: 'Expenses List',
      ADD_EXPENSES: 'Add expenses',
      EDIT_EXPENSES: 'Edit expenses',
      DATE: 'DAte',
      DOC_NO: 'Document number',
      DEALER: 'Dealer name',
      PAYMENT: 'Payment method',
      NET_WORTH_BAHT: 'Net worth(Baht)',
      STATUS: 'Status',
      DOC_NO_DATE: 'Document date',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      READ_FROM: 'Read from',
      LIST: 'List',
      DISCOUNT: 'Discount',
      VALUE: 'Value',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TOTAL: 'Total',
      VAT: 'Vat',
      TYPE_VAT: 'Type VAT',
      VALUE_NOT_VAT: 'Value not VAT',
      NET_WORTH: 'Net worth',
      NOTE: 'Note',
      UNIT: 'Unit',
      CHOOSE_DEALER: 'Choose dealer',
      VALUE_BEFORE_DISCOUNT: 'Vlue before discount',
      VALUE_TOTAL: 'Total',
      DISCOUNT_UNIT: 'Unit Discount',
    },

    ACCEPT_DEBT: {
      TITLE: 'Accept debt list',
      ADD_ACCEPT_DEBT: 'Add accept debt',
      EDIT_ACCEPT_DEBT: 'Edit accept debt',
      DATE: 'Date',
      DEBTOR_NAME: 'Debtor name',
      DEBTOR_CODE: 'Debtor code',
      GET_PAID: 'Get paid',
      DOC_NO: 'Document No.',
      PAYMENT_METHOD: 'Payment method',
      STATUS: 'Status',
      DOC_NO_DATE: 'Document date',
      REF_NO: 'Reference No.',
      REF: 'Reference',
      READ_FROM: 'Read from',
      RAW_MATERAIL_SALE: 'Raw material sale',
      OTHER_INCOME: 'Other income',
      POS_RECEIVE: 'POS Receive',
      DEBTOR: 'Debtor',
      DEBTOR_TYPE: 'Debtor type',
      AMOUNT: 'Payment amount',
      OVERDUE: 'Overdue',
      REMAIN: 'Remain',
      PAYMENT: 'Payment',
      NOTE: 'Note',
      INVOICE_NUMBER: 'Invoice number',
      SALE_DATE: 'Sale date',
      DETAIL: 'Details',
      CREDIT_TERM: 'Credit term (days)',
      DUE_DATE: 'Due date',
      UNPAID_AMOUNT: 'Unpaid amount',
      PAYMENT_DATE: 'Payment date',
      INSTAILLMENT: 'Installment',
      RECEIVED_AMOUNT: 'Received amount',
      OUTSTANDUNG_BALANCE: 'Outstanding balance',
      CHOOSE_DEBTOR: 'Choose debtor',
      CHOOSE_DEBTOR_TYPE: 'Choose debtor type',
      CUSTOMER: 'Customer',
      CHOOSE_CUSTOMER: 'Choose customer',
      LIST: 'List',
      LIST_OVERDUE: 'Only item that overdue',
      DEBT: '-Reduce debt/+Increase debt',
      CUSTOMER_NAME: 'Customer name',
      CUSTOMER_CODE: 'Customer code',
      DEBTOR_INFO: 'Debtor infomation',
      MEMBER_CODE: 'Member code',
      MEMBER_NAME: 'Member name',
      ADDRESS: 'Address',
      PHONE: 'Phone',
      EMAIL: 'Email',
      NO: 'ID card number',
      CREDIT: 'Credit term',
    },

    PAY_OFF_DEBT: {
      TITLE: 'Pay off debt list',
      ADD_PAY_OFF_DEBT: 'Add pay off debt',
      EDIT_PAY_OFF_DEBT: 'Edit pay off debt',
      DATE: 'Date',
      DATE_PAY_OFF: 'Pay off date',
      CREDITOR_NAME: 'Creditor name',
      GET_PAID: 'Get paid',
      DOC_NO: 'Document No.',
      PAYMENT_METHOD: 'Payment method',
      STATUS: 'Status',
      DOC_NO_DATE: 'Document date',
      REF_NO: 'Reference No.',
      REF: 'Reference',
      READ_FROM: 'Read from',
      RAW_MATERAIL_PUCHASES: 'Purchase order',
      RAW_MATERAIL_PUCHASES_PRODUCT: 'Purchase product order',
      RAW_MATERAIL_RECEIVE: 'Receive order',
      EXPENSE: 'Expense',
      CREDITOR: 'Creditor',
      AMOUNT: 'Payment amount',
      OVERDUE: 'Overdue',
      REMAIN: 'Remain',
      PAYMENT: 'Payment',
      NOTE: 'Note',
      TIMES: 'Times',
      REF_NO_DOC: 'Reference doc no.',
      SHOW_LIST: 'Show list',
      VENDOR_CODE: 'Vendor code',
      DETAIL: 'Details',
      CREDIT_TERM: 'Credit term (days)',
      DUE_DATE: 'Due date',
      UNPAID_AMOUNT: 'Unpaid amount',
      PAYMENT_DATE: 'Payment date',
      INSTAILLMENT: 'Installment',
      PAYMENT_AMOUNT: 'Payment amount',
      OUTSTANDUNG_BALANCE: 'Outstanding balance',
      CHOOSE_LIST: 'Choose list',
      CHOOSE_CREDITOR: 'Choose creditor',
      DEALER: 'Dealer',
      CHOOSE_DEALER: 'Choose dealer',
      LIST_BALANCE: 'Only outstanding balance',
      RETURN: 'Return',
      DEALER_NAME: 'Dealer name',
      DEALER_CODE: 'Dealer code',
      DEALER_INFO: 'Dealer infomation',
      ADDRESS: 'Address',
      PHONE: 'Phone',
      EMAIL: 'Email',
      NO: 'Tax Identification Number',
      CREDIT: 'เครดิตเทอม',
      NAME_CONTRACT: 'Contact name',
    },

    EMPLOYEE_WAGES: {
      TITLE: 'Employee wages list',
      ADD_EMPLOYEE_WAGES: 'Add employee wages',
      EDIT_EMPLOYEE_WAGES: 'Edit employee wages',
      DATE: 'date',
      STAFF_TYPE: 'Staff type',
      STATUS: 'Status',
      DOC_NO: 'Document No.',
      DOC_NO_DATE: 'Document date',
      REF_NO: 'Reference No.',
      REF: 'Reference',
      NAME: 'Staff name',
      POSITION: 'Position',
      WAGES: 'Wages (Baht)',
      OVERTIME: 'Overtime',
      SOCIAL_SECURITY: 'Social security',
      OTHER: 'Other',
      WAGES_NET_WORTH: 'Wages (net)',
      NOTE: 'Note',
      WAGES_AMOUNT: 'Wages (sum)',
      WAGES_TOTAL: 'Wages total',
      CODE: 'Staff Code',
      PAY_DATE: 'Pay date',
      WAGE: 'Salary/Wages',
    },

    MEMBER_DIVIDEND_PAYMENT: {
      TITLE: 'Member diviend payment list',
      ADD_MEMBER_DIVIDEND_PAYMENT: 'Add Member diviend payment',
      EDIT_MEMBER_DIVIDEND_PAYMENT: 'Edit Member diviend payment',
      DATE: 'Date',
      STATUS: 'Status',
      MEMBER: 'Member',
      SHARE_RATIO: 'Share ratio',
      AMOUNT_DIVIDENDS_PAID: 'Amount dividends paid',
      MEMBER_HOLD_SHARE: 'Member hold share',
      DOC_NO: 'Document No.',
      DOC_NO_DATE: 'Document date',
      REF_NO: 'Reference No.',
      REF: 'Reference',
    },

    OTHER_INCOME_ACCOUNT: {
      TITLE: 'Other income list',
      ADD_OTHER_INCOME: 'Add Other income',
      EDIT_OTHER_INCOME: 'Edit Other income',
      DATE: 'Date',
      PAYMENT: 'Payment type',
      NET_WORTH_BAHT: 'Net worth (Baht)',
      STATUS: 'Status',
      DOC_NO: 'Document No.',
      DOC_NO_DATE: 'Document date',
      PAYMENT_DATE: 'Payment date',
      REF_NO: 'Reference No.',
      REF: 'Reference',
      CUSTOMER: 'Customer',
      ADDRESS: 'Address',
      TAX_ID: 'Tax Identification Number',
      SALE_PERSON: 'Sale person',
      NOTE: 'Note',
      LIST_OTHER_INCOME: 'Other income list',
      LIST: 'List',
      DISCOUNT: 'Discount',
      VALUE: 'Value',
      PRICE_AFTER_DISCOUNT: 'Price after discount',
      HAS_VAT: 'Has vat',
      NO_VAT: 'No has vat',
      TOTAL: 'Total',
      UNIT: 'Unit',
      VALUE_AFTER_DISCOUNT: 'Value after discount',
      TYPE_VAT: 'Vat type',
      VALUE_NOT_VAT: 'Value not vat',
      VAT: 'VAT',
      NET_WORTH: 'Net worth',
      AMOUNT: 'Amount',
      ITEM_NO_TAX: 'Product item no Tax',
      ITEM_TAX: 'Product item have Tax',
      TAX_LIST: 'TAX',
      PRICE_BEFORE_TAX: 'Price before TAX',
      TOTAL_LIST: 'Total',
      TOTAL_TABLE: 'Total',
      DISCOUNT_UNIT: 'Unit Discount',
    },

    //Manage-farming
    ACTIVITY_TYPE: {
      TITLE: 'Activity type list',
      ACTIVITY_TYPE: 'Activity type',
      ADD_ACTIVITY_TYPE: 'Add activity type',
      EDIT_ACTIVITY_TYPE: 'Edit activity type',
    },
    ACTIVITY_INFORMATION: {
      TITLE: 'Current version list',
      LOT: 'Lot',
      CONTRACT: 'Contract',
      AMOUNT_DAY: 'Amount day',
      PLAN: 'Production plan',
      TITLE_ACTIVITY: 'Activity list',
      CREATE_ACTIVITY: 'Create activity',
      START_DATE: 'Start date',
      STEP: 'Steps',
      HARVEST_DATE: 'Harvest date',
      STEP_TO_DO: 'Step to do',
      ACTIVITY: 'Activity',
      DATE: 'Date',
      TIME: 'Time',
      AMOUNT: 'Amount',
      RECCOMEND_AMOUNT: 'Reccomend amount',
      PRICE_UNIT: 'Price per unit',
      EXPENSE: 'Expense',
      FROM1: 'Inventory form',
      FROM2: 'Out of stock form',
      FROM3: 'Expense form',
      FROM4: 'Environment form',
      FROM5: 'Growth form',
      FROM6: 'Harvest form',
      PRODUCT_NON: 'Product out of stock',
      PRODUCT: 'Product in stock',
      RAW_MAT: 'Product',
      AMOUNT_STOCK: 'Amount inventory',
      UNIT: 'Unit',
      REMARK: 'Remark',
      MONEY: 'Total money',
      FARM: 'Farm',
      DESCRIPTION: 'Description',
      STATUS: 'Status',
      REF: 'Referance',
      REVERSE: 'Reverse',
      REVERSED: 'Reversed',
    },
    FARMIHNG_ACTIVITY: {
      TITLE: 'Farming activity list',
      NAME: 'Name',
      TYPE: 'Type',
      RAW_MATERIAL: 'Raw material',
      UNIT: 'Unit',
      REMAIN: 'Remain',
      CATEGORY: 'Category',
      ADD_FARMIHNG_ACTIVITY: 'Add farming activity',
      UPDATE_FARMIHNG_ACTIVITY: 'Edit farming activity',
      SHOW_FARMIHNG_ACTIVITY: 'Farming activity',
      ACTIVITY_NAME: 'Activity name',
      ACTIVITY_TYPE: 'Activity type',
      ACTIVITY_CATEGORY: 'Activity category',
      CUT_STOCK: 'Cut stock',
      NO_CUT_STOCK: 'No cut stock',
      ADD_STOCK: 'Add stock',
      CROP_REQUIREMENT: 'Standard value',
    },
    FARMIHNG_TYPE: {
      TITLE_LIST: 'Farming type list',
      TITLE_ADD: 'Create farming type',
      TITLE: 'Farming type list',
      FARMIHNG_TYPE: 'Farming type',
      ADD_FARMIHNG_TYPE: 'Add farming type',
      EDIT_FARMIHNG_TYPE: 'Edit farming type',
      FARMIHNG_NAME: 'Name farming tyoe',
      PROCEDURE_FARMIHNG: 'Procedure farming',
      ADD_PROCEDURE_FARMIHNG: 'Add procedure farming',
      PROCEDURE: 'Procedure',
      PROCEDURE_FARMIHNG_NAME: 'Name procedure farming',
      ACTIVITY: 'Activity',
      ADD_ACTIVITY: 'Add activity',
      HARVEST_TYPE: 'Harvest type',
      HARVEST_CYCLE: 'harvest cycle',
      START_YIELDING: 'Start yeild',
      END_YIELDING: 'End yeild',
      AMOUNT_SETUP_DATE: 'Setup time',
      AMOUNT_CYCLE: 'Amount cycle',
      IDLE_DATE: 'Idle time life cycle',
      AMOUNT_PRODUCT: 'Amount date harvest',
      YIELD_HAVEST: 'Yield/harvest cycle',
      YIELD_FIELD: 'Yield',
      YIELD_UNIT: 'Unit',
      AMOUNT_INITIAL: 'Amount initial',
      INITIAL_UNIT: 'Unit',
      INITIAL_COST: 'Initial cost',
      FOOD_COST: 'Food cost',
      PROFIT: 'Profit',
      CARCASS_PRICE: 'Sale price',
      HARVEST_TYPE_FILTER: 'Harvest type',
      PRODUCT: 'Product',
    },

    CROP_REQUIREMENT: {
      TITLE_LIST: 'List Standard value',
      EDIT: 'Edit Standard value',
      CREATE: 'Create Standard value',
      NAME: 'Name',
      CONDITION_TYPE: 'Condition type',
      UNIT: 'Unit',
      OWNER: 'Farm',
      REF: 'Referance',
      FORMULA: 'Formula',
      REQ_CONDITIONL: 'Requirement condition',
      START_CONDITION: 'Start condition',
      END_CONDITION: 'End condition',
      IS_DEFAULT: 'Default value range',
      VALUE: 'Default value',
      MIN: 'Start value',
      MAX: 'End value',
    },
    ORDER_PLAN: {
      TITLE: 'Order plan list',
      ADD: 'Create order plan',
      SHOW: 'Order plan',
      DOC_NO: 'Document number',
      NAME: 'Customer name',
      SHIPPING_ADDRESS: 'Shipping address',
      DATE: 'Date',
      RECEIVE_DATE: 'Receive date',
      CONTRACT_TERM: 'Contract term',
      END_DATE: 'End date',
      LIST: 'List',
      AMOUNT: 'Amount',
      UNIT: 'Unit',
      PROODUCTION_ORDER: 'Production order',
      RECORDER: 'Recorder',
      REF_NO: 'Reference NO.',
      REF: 'Reference',
      LIST_ORDER: 'Order list',
      ORDER: 'Order',
      FARMER: 'Farmer',
      REVERSE: 'Reverse',
    },
    ANALYZE_ORDERS: {
      TITLE: 'การวิเคราะห์',
      ADD: 'Add farmer',
      CHOOSE: 'choose farmer',
      SIZE: 'Size',
      REMIAN: 'Remain area',
    },
    REPORT_PLAN: {
      TITLE: 'รายงานวางแผนการผลิต',
    },

    FARMIHNG_INFORMATION: {
      TITLE: 'Farming information list',
      FARMIHNG_INFORMATION: 'Farming information',
      ADD_FARMIHNG_INFORMATION: 'Add farming information',
      EDIT_FARMIHNG_INFORMATION: 'Edit farming information',
      DATE: 'Date',
      LOT: 'Lot',
      PROCEDURE: 'Procedure',
      ACTIVITY: 'Activity',
      RAW_MATERIAL: 'Raw materail',
      REMAIN: 'Remain',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      TIME: 'Time',
      FARMING_PROCEDURE: 'Farming procedure',
      FARMING: 'Farm',
      AGENT: 'Agent',
    },
    EXPENSE_FARMING_INFORMATION: {
      TITLE: 'Expense information list',
      EXPENSE_INFORMATION: 'Expense information',
      ADD_EXPENSE_INFORMATION: 'Add expense information',
      EDIT_EXPENSE_INFORMATION: 'Edit expense information',
      DATE: 'Date',
      LOT: 'Lot',
      PROCEDURE: 'Procedure',
      ACTIVITY: 'Activity',
      AMOUNT: 'Amount',
      FARMING_PROCEDURE: 'Farming procedure',
    },
    ENVIRONMENT_INFORMATION: {
      TITLE: 'Environment information list',
      ENVIRONMENT_INFORMATION: 'Environment information',
      ADD_ENVIRONMENT_INFORMATION: 'Add environment information',
      EDIT_ENVIRONMENT_INFORMATION: 'Edit environment information',
      DATE: 'Date',
      LOT: 'Lot',
      PROCEDURE: 'Procedure',
      ACTIVITY: 'Activity',
      AMOUNT: 'Amount',
      TIME: 'Time',
      EVALUATE: 'Evaluate',
      FARMING_PROCEDURE: 'Farming procedure',
    },
    WASTING_INFORMATION: {
      TITLE: 'Wasting information list',
      WASTING_INFORMATION: 'Wasting information',
      ADD_WASTING_INFORMATION: 'Add wasting information',
      EDIT_WASTING_INFORMATION: 'Edit wasting information',
      DATE: 'Date',
      LOT: 'Lot',
      PROCEDURE: 'Procedure',
      ACTIVITY: 'Activity',
      AMOUNT: 'Amount',
      TIME: 'Time',
      FARMING_PROCEDURE: 'Farming procedure',
    },
    GROWTH_INFORMATION: {
      TITLE: 'Growth information list',
      GROWTH_INFORMATION: 'Growth information',
      ADD_GROWTH_INFORMATION: 'Add growth information',
      EDIT_GROWTH_INFORMATION: 'Edit growth information',
      DATE: 'Date',
      LOT: 'Lot',
      PROCEDURE: 'Procedure',
      FARMING_PROCEDURE: 'Farming procedure',
      ACTIVITY: 'Activity',
      AMOUNT: 'Amount',
      ADD_AMOUNT: 'Add amount',
    },
    HARVEST_INFORMATION: {
      TITLE: 'Havest information list',
      HARVEST_INFORMATION: 'Havest information',
      ADD_HARVEST_INFORMATION: 'Add havest information',
      EDIT_HARVEST_INFORMATION: 'Edit havest information',
      HAVEST: 'Havest information',
      ADD_HARVEST: 'Add Data',
      DATE: 'Date',
      FARM_NAME: 'Farm name',
      LOT: 'Lot',
      TIME: 'Time',
      PROCEDURE: 'Procedure',
      FARMING_PROCEDURE: 'Farming procedure',
      ACTIVITY: 'Activity',
      AMOUNT: 'Amount',
    },

    //Contract lot management
    CONTRACT_INFORMATION: {
      TITLE_LIST: 'Contract information list',
      TITLE_ADD: 'Contract information',
      DOC_NO: 'Document number',
      MEMBER: 'Member',
      CONTRACT_NAME: 'Contract name',
      CONTRACT_DATE: 'Contract date',
      END_DATE: 'End date',
      INITIAL_RAW_MATERIAL: 'Initial raw material list',
      CONTRACT_NO: 'Contract number',
      FARMING_DATE: 'Farming date',
      PRODUCT: 'Product',
      LOT_AMOUNT: 'Lot amount',
      LOT_AMOUNT_PER: 'Lot per amount',
      UNIT: 'Unit',
      RAISING_AREA_TYPE: 'Raising area type',
      RAISING_AREA_SIZE: 'Raising area size',
      START_SIZE: 'Start size',
      START_WEIGHT: 'Start weight',
      INSURANCE_PRICE: 'Insurance price',
      SECURITY_DEPOSIT: 'Security deposit',
      REVENUE_SHARE: 'Revenue share',
      WAGES: 'Wages',
      NOTE: 'Note',
      UNIT_ADD: 'Unit',
      IS_ANIMAL: 'Is Animal type',
      ALL_AREA: 'Area size all',
      AREA: 'Area',
      REMAIN: 'Remain area',
      CANCEL: 'Cancel Contract',
      CANCEL_DONE: 'Cancel Contract Done',
      STATUS: 'Status',
    },
    LOT_INFORMATION: {
      TITLE_LIST: 'Lot information list',
      TITLE_ADD: 'Create lot information',
      TITLE_EDIT: 'Edit lot information',
      START_FARMING_DATE: 'Start farming date',
      LOT_NAME: 'Lot name',
      INITIAL_RAW_MATERIAL: 'Initial raw material',
      AMOUNT: 'Amount',
      UNIT: 'Unit',
      FARMING_TYPE: 'Farming type',
      NUM_OF_FARMING_DATE: 'Number of farming date',
      DATE: 'Date',
      CONTRACT: 'Contract',
      INITIAL_AMOUNT: 'Initial amount',
      UNIT_ADD: 'Unit',
      IS_CLOSE: 'Is close',
      CLOSE_DATE: 'Close date',
      CHOOSE_CONTRACT: 'Choose contract',
    },

    //Report
    INVENTORY_REPORT: {
      SELECT_DATE_RANGE: 'Date range',
      UP_TO_DATE: 'Up to date',
      DATE: 'date',
    },

    PRODUCTION_EFFICIENCY: {
      PRODUCT_COST: {
        TITLE: 'Product Cost Report',
        CONTRACT: 'Contract',
        CHOOSE_CONTRACT: 'Choose contract',
        START_FARMING_DATE: 'Start farming date',
        LOT: 'Lot',
        RAISING_PERIOD: 'Raising period (Days)',
        TOTAL_COST: 'Total cost (Baht)',
        DETAILS: 'Details',
        PROCEDURE_FARMING: 'Procedure farming',
        FARMING_ACTIVITY: 'Farming activity',
        CHOOSE_PROCEDURE_FARMIHNG: 'Choose procedure farming',
        CHOOSE_FARMING_ACTIVITY: 'Choose farming activity',
        LIST: 'List',
        TYPE: 'Type',
        AMOUNT: 'Amount',
        UNIT: 'Unit',
        AVERAGE_UNIT_PRICE: 'Average unit price',
        VALUE: 'Value (Baht)',
      },
      FEED_FERTILIZE_DRUG: {
        TITLE: 'Feeding / Fertilizing / Medication report',
        SELECT_DATE_RANGE: 'Date range',
        UP_TO_DATE: 'Up to date',
        LIST: 'List',
        CONTRACT: 'Contract',
        LOT: 'Lot',
        TYPE: 'Type',
        AMOUNT: 'Amount',
        UNIT: 'Unit',
        DETAILS: 'Details',
      },
      GROWTH_REPORT: {
        TITLE: 'Growth Report',
        LIST: 'List',
        CONTRACT: 'Contract',
        LOT: 'Lot',
        CHOOSE_LIST: 'Choose list',
        CHOOSE_CONTRACT: 'Choose contract',
        CHOOSE_LOT: 'Choose lot',
        AVERAGE_VOLUME: 'Average volume',
        UNIT: 'Unit',
        DETAILS: 'Details',
        NOTE: 'Note',
        DATE: 'Date',
        AMOUNT: 'Amount',
      },
      PRODUCT_QUANTITY: {
        TITLE: 'Product Quantity Report',
        LIST: 'List (production)',
        CONTRACT: 'Contract',
        LOT: 'Lot',
        CHOOSE_LIST: 'Choose list (production)',
        CHOOSE_CONTRACT: 'Choose contract',
        CHOOSE_LOT: 'Choose lot',
        FEEDING_PERIOD: 'Feeding period (days)',
        ESTIMATED_INCOME: 'Estimated Income (Baht)',
        TOTAL: 'Total',
        DETAILS: 'Details',
        START_DATE: 'Start_date',
        TOTAL_LIST: 'Total of each item',
      },
      WASTING_REPORT: {
        TITLE: 'Wasting Report',
        LIST: 'List (production)',
        CONTRACT: 'Contract',
        LOT: 'Lot',
        CHOOSE_LIST: 'Choose list (production)',
        CHOOSE_CONTRACT: 'Choose contract',
        CHOOSE_LOT: 'Choose lot',
        TOTAL_LOSS: 'Total loss',
        FEEDING_PERIOD: 'Feeding period (days)',
        DETAILS: 'Details',
        TOTAL_COST: 'Total cost (Baht)',
        START_DATE: 'Start_date',
        UNIT: 'Unit',
        AMOUNT: 'Amount',
        DATE: 'Date',
        LIST_: 'List',
        COST: 'Cost (Baht)',
      },
    },

    //Setting
    GENERAL_INFORMATION: {
      TITLE: 'General Setting',
      IMAGE: 'Brand/Farm/Organization Image',
      NAME: 'Farm/Business Name',
      NAME_EN: 'Farm/Business Name(EN)',
      BRANCH_NAME: 'Branch name',
      BRANCH_CODE: 'Brranch code',
      TAX_ID: 'Tax Identification Number',
      REGISTER: 'Regiater',
      VAT: 'Vat',
      VAT_TYPE: 'Vat type',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      PHONE: 'Phone',
      EMAIL: 'Email',
      FAX: 'Fax',
      PROFIT: 'กำไรเป้าหมาย',
      TEXT_FOOTER_BILL: 'Text footer bill',
      IMAGE_FOOTER_BILL: 'Image footer bill',
    },
    CUSTOMER_INFORMATION: {
      TITLE_LIST: 'Customer List',
      CREATE: ' Create Customer',
      EDIT: 'Edit Customer',
      NAME_LIST: 'Name',
      PHONE: 'Phone',
      TITLE: 'Customer Information Setting',
      NAME: 'Company/Store Name',
      TAX_ID: 'Tax Identification Number',
      SHIPPING: 'Shipping address',
      TAX_ADDRESS: 'Tax Address',
      SAME_ADDRESS: 'Same Address',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      CREDIT_DAY: 'Credit Day',
      AMOUNT_DATE: 'Amount Date',
      CONTACT_NAME: 'Contact Name',
      CONTACT_PHONE: 'Contact Phone',
      EMAIL: 'Email',
      FAX: 'Fax',
      CODE: 'Customer code',
      BRANCH: 'Branch',
      BRANCH_CODE: 'Branch code',
      LINE: 'Line',
    },
    SUPPLIER_INFORMATION: {
      TITLE_LIST: 'Supplier List',
      CREATE: ' Create Supplier',
      EDIT: 'Edit Supplier',
      NAME_LIST: 'Name',
      PHONE: 'Phone',
      TITLE: 'Supplier Information Setting',
      NAME: 'Company/Store Name',
      TAX_ID: 'Tax Identification Number',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      CREDIT_DAY: 'Credit Day',
      AMOUNT_DATE: 'Amount Date',
      CONTACT_NAME: 'Contact Name',
      EMAIL: 'Email',
      FAX: 'Fax',
      CODE: 'Supplier code',
    },
    ACCOUNT_INFORMATION: {
      TITLE_LIST: 'Bank Account List',
      BANK: 'Bank',
      ACCOUNT_NAME: 'Account Name',
      ACCOUNT_NUMBER: 'Account Number',
      ADD_BANK_ACCOUNT: 'Add Bank Account',
      EDIT_BANK_ACCOUNT: 'Edit Bank Account',
      IS_QR_CODE: 'Is Qr Code',
      IS_CREDIT_CARD: 'Is Credit Card',
    },
    EXPENSE_INFORMATION: {
      TITLE_LIST: 'Expense List',
      NAME: 'Expense Name',
      DESCRIPTION: 'Description',
      TYPE: 'Expense Type',
      ADD_EXPENSE: 'Add Expense',
      EDIT_EXPENSE: 'Edit Expense',
    },
    OTHER_INCOME: {
      TITLE_LIST: 'Other income',
      NAME: 'Other income name',
      ADD_OTHER_INCOME: 'Add other income',
      EDIT_OTHER_INCOME: 'Edit other income',
    },
    STAFF_INFORMATION: {
      TITLE_LIST: 'Staff list',
      TITLE_LIST_FARM: 'Staff list(Farm)',
      TITLE_LIST_AGENT: 'Staff list(Agent)',
      CREATE: ' Create Staff',
      EDIT: 'Edit Staff',
      NAME_LIST: 'Name',
      USERNAME: 'Username',
      TITLE: 'Staff information setting',
      IMAGE: 'Image',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      NICK_NAME: 'Nick name',
      PHONE: 'Phone',
      EMAIL: 'Email',
      BIRTHDAY: 'Date of birth',
      NO_ID: 'Identification Number',
      CARD_ADDRESS: 'Card address',
      CURENT_ADDRESS: 'Curent address',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      SATRT_DATE: 'Start Date',
      END_DATE: 'End Date',
      STAFF_POSITION: 'Staff position',
      STAFF_TYPE: 'Staff type',
      SALARY: 'Salary',
      STAFF_STATUS: 'Staff status',
      PASSWORD: 'Password',
      CON_PASSWORD: 'Confirm password',
      CHOOSE_DATE: 'Choose Date',
      AMOUNT_SALARY: 'AMOUNT',
      USERNAME_PLACEHODER: 'Username (English&Number)',
      PASSEORD_PLACEHODER: 'Password (English&Number)',
      CON_PASS_PLACEHODER: 'Confirm password (English&Number)',
      IS_PIN: 'Create PIN',
      PIN: 'PIN',
      CON_PIN: 'Confirm PIN',
      ADD: 'Address according to ID card',
      ROLE: 'Permission',
      SYSTEM_ACCOUNT_NAME: 'Farm',
      AGENT: 'Agent',
    },
    PERMISSION: {
      TITLE_LIST: 'Permission List',
      NAME: 'Permission',
      ADD_EXPENSE: 'Add Permission',
      EDIT_EXPENSE: 'Edit Permission',
      NAME_POSITION: 'Position name',
    },
    POSITION: {
      TITLE_LIST: 'Position List',
      NAME: 'Position',
      ADD_EXPENSE: 'Add Position',
      EDIT_EXPENSE: 'Edit Position',
      NAME_POSITION: 'Position name',
    },
    UNIT: {
      TITLE_LIST: 'Unit List',
      NAME: 'Unit name',
      ADD_UNIT: 'Add Unit',
      EDIT_UNIT: 'Edit Unit',
    },
    RAW_MATERIAL_TYPE: {
      TITLE_LIST: 'Raw material type list',
      NAME: 'Raw material name',
      CREDIT: 'Credit account number',
      DEBIT: 'Debit account number',
      ADD_RAW_MATERIAL: 'Add Raw material Type',
      EDIT_RAW_MATERIAL: 'Edit Raw material Type',
    },
    RAW_MATERIAL_LIST: {
      TITLE_LIST: 'Raw material list',
      CREATE: 'Create raw material',
      EDIT: 'Edit raw material',
      NAME: 'Raw material name',
      CODE: 'Raw material code',
      BARCODE: 'Barcode',
      STARDARD_PRICE: 'Stardard purchase price',
      MINIMUM_AMOUNT: 'Minimum amount',
      RAW_MATERIAL_TYPE: 'Raw material type',
      IS_PRODUCT: 'Is product',
      IS_VAT: 'Is vat',
      IS_EXPENSE: 'Is expense',
      UNIT: 'Unit',
      BATH: 'Bath',
      MULTIPLIER: 'Multiplier',
      MAIN_UNIT: 'Main unit',
      SUB_UNIT: 'Sub unit',
      ADD_RAW_MATERIAL: 'Add Raw material',
      EDIT_RAW_MATERIAL: 'Edit Raw material',
    },
    INITIAL_CASH: {
      TITLE_LIST: 'Initial cash list',
      AMOUNT: 'Amount',
      DATE: 'Date',
      SHOW_INITIAL_CASH: 'Initial cash',
      ADD_INITIAL_CASH: 'Add Initial cash',
      EDIT_INITIAL_CASH: 'Edit Initial cash',
    },
    INITIAL_RAW_MATERIAL: {
      TITLE_LIST: 'Initial raw material list',
      ADD: 'Create initial raw material',
      DATE: 'Date',
      DATE_CREATE: 'Create date',
      RAW_MATERIAL_TYPE: 'Raw material type',
      AMOUNT: 'Amount',
      UNIT: 'Unit',
      UNIT_COST: 'Unit cost',
      TOTAL: 'Total (Bath)',
      CHOOSE_DATE: 'Choose Date',
      TITLE: 'Initial raw material',
    },
    SHAREHOLDER_INFORMATION: {
      TITLE_LIST: 'Shareholder list',
      CREATE: 'Create shareholder',
      EDIT: 'Edit shareholder',
      NAME_LIST: 'Name',
      AMOUNT: 'Amount (Unit)',
      RATIO: 'Ratio',
      PHONE: 'Phone',
      TITLE: 'Shareholder information setting',
      IMAGE: 'Image',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      NATIONALITY: 'Nationality',
      AMOUNT_SHARE: 'Amount',
      AMOUNT_PLACEHOLDER: 'Amount',
      UNIT: 'Unit',
      ADDRESS: 'Address',
      PROVINCE: 'Province',
      TAMBON: 'Tambon',
      AMPHUR: 'Amphur',
      POST_CODE: 'Post Code',
      SATRT_DATE: 'Start Date',
      MEMBER_NAME: 'Member name',
      SHARE_RATIO: 'Share ratio (%)',
      DIVIDEND_AMOUNT: 'Dividend amount',
      DIVIDEND_PAY_DATE: 'Dividend paymeny date',
    },
    DIVIDEND_RATIOS: {
      TITLE_LIST: 'Dividend ratio list',
      AMOUNT: 'Amount (%)',
      NAME: 'Name',
      ADD_DIVIDEND_RATIOS: 'Add Dividend ratio',
      EDIT_DIVIDEND_RATIOS: 'Edit Dividend ratio',
    },
    WAREHOUSE_SETTING: {
      TITLE_LIST: 'Warehouse setting',
      SETTING: 'Setting',
      OPEN: 'Open',
      CLOSE: 'Close',
      NAME: 'Warehouse name',
    },
    MENU_SETTING: {
      TITLE_LIST: 'Menu List',
      CREATE: 'Create Menu',
      EDIT: 'Edit Menu',
      IMAGE: 'Image menu',
      CODE_MENU: 'Code menu',
      NAME: 'Name menu',
      RAW_MWTERIAL: 'Raw material',
      BARCODE: 'Barcode',
      PRICE: 'Price',
      WEIGHT: 'Sale by weight',
      UNIT: 'Unit',
      FEATURES: 'Other features',
      RECOMMENT: 'Recomment menu',
      PROMOTION: 'About promotion',
      NOT: 'Not promotion',
    },
    PROMOTION_SETTING: {
      TITLE_LIST: 'Promotion list',
      CREATE: 'Create promotion',
      EDIT: 'Edit promotion',
      CODE: 'Code',
      NAME: 'Name',
      TYPE: 'Type',
      STATUS: 'Status',
      SETTING: 'Setting',
      OPEN: 'Open',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      START_TIME: 'Start time',
      END_TIME: 'End time',
      DESCRIPTION: 'Description',
      DISCOUNT: 'Discount',
      UNIT: 'Unit',
      CONDITION: 'Condition',
      PRODUCT: 'Participating products',
    },
    CANCELLATION_SETTING: {
      TITLE_LIST: 'Cancellation list',
      CREATE: 'Create cancellation',
      EDIT: 'Edit cancellation',
      NAME: 'Name cancellation',
    },
    PRINTER_SETTING: {
      TITLE_LIST: 'Priter list',
      CREATE: 'Create printer',
      EDIT: 'Edit printer',
      NAME: 'Name',
      SIZE: 'Size paper',
      TYPE: 'Type conneciton',
      PORT: 'Port',
    },
    POS_SETTING: {
      TITLE_LIST: 'POS list',
      CREATE: 'Add POS',
      EDIT: 'Edit POS',
      STATUS: 'Is main POS',
      NAME: 'Name',
      CODE: 'Receipt and Invoice Code',
      NUMBER: 'Cash register number',
      PRINTER: 'Printer',
      TYPE: 'Type print',
      AMOUNT: 'Amount',
    },
    CATEGORY_SETTING: {
      TITLE_LIST: 'Category and product list',
      CREATE: 'Add ategory and product',
      EDIT: 'Edit Category and product',
      TAB1: '1 Category and product detail',
      TAB2: '2 Product',
      NUMBER: 'Order',
      NAME: 'Name',
      READY: 'Ready for sale',
      READY_ALL: 'Ready for sale (All category)',
      ORDER: 'Order',
      NAME_PRODUCT: 'Name',
      PRODUCT: 'Ready for sale (Product)',
      SHOW_BILL: 'Show on bill',
      SHOW_DISPLAY: 'Show on display',
    },
    ROUNDING_OFF_SETTING: {
      TAB1: 'Round weight ',
      TAB2: 'Round the end of bill',
      ROUND_UP_WEIGHT: 'Round up weight',
      ROUND_DOWN_WEIGHT: 'Round down weight',
      ROUND_UP: 'Round up',
      ROUND_DOWN: 'Round down',
      BAHT: 'Baht',
      SALUNG: 'Salung',
      CHOOSE: 'Choose unit',
    },
    TRANSFER_SETTING: {
      TITLE_LIST: 'Transfer between warehouse list',
      CREATE: 'Create transfer between warehouse',
      EDIT: 'Edit transfer between warehouse',
      SOURCE_WAREHOUSE: 'Source warehouse',
      DESTINATION_WAREHOUSE: 'Destination warehouse',
      STATUS: 'Status',
      DATE: 'Date',
      READ_FROM: 'Read form',
      REF_NO: 'Reference No.',
      REF: 'Reference',
      READ_FROM_ADJUST: 'อ่านจากใบปรับปรุงเดิม',
      RAW_MATERIAL: 'Raw materail',
      PURCHASE: 'Purchase order',
      RECEIVE: 'Product purchase order',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      LIST: 'List',
      UNIT: 'Unit',
      AMOUNT: 'Amount',
      AMOUNT_TRANFER: 'Amount Transfer',
      UNIT_PRICE: 'Unit price',
      TOTAL_VALUE: 'Total value',
      TOTAL: 'Total',
    },

    BTN: {
      EDIT: 'Edit',
      ADD: 'Add',
      MORE: 'More',
      DELETE: 'Delete',
      CANCEL: 'Cancel',
      SAVE: 'Save',
      CLOSE: 'Close',
      ADD_LIST: 'Add List',
      REVERSED: 'Reversed',
      REVERSE: 'Reverse',
      EXPORT: 'Export',
      SEND: 'Send',
      SEE_DETAILS: 'See details',
      PRINT: 'Print',
      COPY: 'Copy',
      ALL_COPY: 'All copy',
      CLOSE_LOT: 'Close lot',
      CLOSE_LOT_DONE: 'Closed',
      PRINT_XLS: 'Print xls',
      NEXT: 'Next',
      PREVIOUNS: 'Previous',
      CANCEL_LOT: 'Cancel Lot',
      CANCEL_LOT_DONE: 'Cancel lot Done',
      HAVE: 'Have',
      NOT_HAVE: 'Not Have',
      CAN: 'Yes',
      CAN_NOT: 'No',
      CANCEL_CONTRACT: 'Cancel Contract',

      MENU_FARMING: {
        FARMING_INFORMATION: 'Farming information',
        EXPENSE_INFORMATION: 'Expense information',
        ENVIRONMENT_INFORMATION: 'Environment information',
        WASTING_INFORMATION: 'Wasting information',
        GROWTH_INFORMATION: 'Growth information',
        HAVEST_INFORMATION: 'Havest information',
      },
    },
    INPUT: {
      SEARCH: 'Search',
    },
    DATA_TABLE: {
      NO: 'No.',
      MANAGE: 'Manage',
      NO_DATA: 'No records found',
      TOTAL: 'Total',
    },
    ERROR: {
      IMAGE_OVER_SIZE: 'The file size must not exceed 500 kB.',
    },
    PLACEHOLDER: {
      PROVINCE: 'Choose province',
      AMPHUR: 'Choose amphur',
      TAMBON: 'Choose tambon',
      POSITION: 'Choose position',
      STAFF_TYPE: 'Choose staff type',
      STAFF_STATUS: 'Choose staff status',
      PERMISSION: 'Choose permission',
      RAW_MATERIAL_TYPE: 'Choose raw material type',
      DATE: 'Choose Date',
      TIME: 'Choose time',
      RAW_MATERIAL: 'Choose raw material',
      BATH: 'Bath',
      UNIT: 'Unit',
      DAY: 'Days',
      FARM: 'Farm',
    },
    VALIDATOR: {
      REQUIRED: 'Please fill out the list',
    },

    FILTERS: {
      THB: 'Bath',
      PERCENT: 'Percent',
      REEIVE: 'Receive',
      EXPENSE: 'Expense',
      PURCHASE_PRODUCT: 'Purchase prroduct',
      PURCHASE: 'Purchase',
      PAYMENT_1: 'Partial payment',
      PAYMENT_2: 'Full payment',
      SALE: 'Rawmaterial sale',
      OTHER_INCOME: 'Other income',
      AGENT: 'Agent',
      FARM: 'Farm',
      ALL_BILL: 'All bill',
      CATEGORY: 'By category',
      PRODUCT: 'By product   ',
      LIST_NAME_AGENT: 'List Agent Name',
    },

    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
  },
};
